// extracted by mini-css-extract-plugin
export default {"reviews":"io","yotpo":"jo","wrapper":"ko","review_list":"lo","carousel":"mo","swiper-slide":"no","review":"oo","title":"po","verified":"qo"};
    if(module.hot) {
      // 1713809675449
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  